import { render } from "./fileSelect.vue?vue&type=template&id=585d518c&ts=true"
import script from "./fileSelect.vue?vue&type=script&lang=ts"
export * from "./fileSelect.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__